export default __webpack_public_path__ + "static/media/MP_Skills_Job-type_01.e617236e.png";